import { type MetaFunction } from '@remix-run/node'

export const meta: MetaFunction = () => [
	{ title: 'Automatic Payments' },
	{
		name: 'description',
		content: 'How using Automatic Payments can lower your insurance bill.',
	},
]

export default function Component() {
	return (
		<>
			<h1 className="py-3 text-4xl font-black">
				Automatic Payments: Shrink your Bill
			</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				When an insurance company identifies attributes among its customers that
				are easier to service, the sensible response is to reward "good
				behavior" accordingly. One attribute that indicates a customer's
				aptitude to pay bills on time, every time, is enrollment in automatic
				payments. It goes without saying that customers with automatic payments,
				or Electronic Funds Transfer (EFT) are never going to miss a payment or
				be late.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				In addition to paying for a postage stamp every time you pay your bill,
				did you know that you are probably paying for the company to mail you a
				bill and then have someone open your payment on the other end?
				Typically, billing service fees are approximately $5 to $10 per bill.
				Many insurers waive or significantly lower the billing fees for
				policyholders who participate in automatic payments. In addition to
				savings in your billing fees, see if your company offers a discount
				against the actual premium portion of your bill for enrolling in EFT.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Because of the legal contracts involved with an insurance policy, many
				people find that they get a lot of mail from the insurance company. Some
				top insurance carriers are "going green" and giving customers the option
				to have a paperless relationship. This is innovative because your policy
				documents and bills come electronically, delivered instantly to your
				email address.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				You might be surprised to find out how much time and money these simple
				tips can save you. Please give the office a call and we can help you
				find out what you can save by taking advantage of automatic payments or
				going paperless.
			</p>
		</>
	)
}
